const doc = [({"en":({"js":({"merfoto":({"basket":({"basket_item_card":({"index":({"photo":"Photo"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;